'use client';
import { HStack, Text } from '@chakra-ui/react';
import * as React from 'react';
import { useRouter } from '@/i18n/routing';

interface LogoProps {
  fontSize?: number;
  width?: number;
}

export function Logo({ fontSize = 14, width = 24 }: LogoProps) {
  const router = useRouter();
  return (
    <HStack onClick={() => router.push('/')}>
      <svg
        width={`${width}px`}
        height={`${width}px`}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4618_2358)">
          <g clipPath="url(#clip1_4618_2358)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.8678 9.16123H16.3258L18.6018 2.76104L17.2638 1.68305L15.2905 6.67979L11.0757 -0.00683594L9.11118 0.575603L14.8347 9.1119L14.8678 9.16123ZM2.73159 4.26465L13.9894 10.0699V11.9844L3.73889 20.3601L1.61089 18.1695L1.71471 18.0944L11.2274 11.2591L0.912109 6.64963L2.73159 4.26465ZM11.2793 23.6709L15.0545 12.8034L16.6655 12.7725L21.0121 19.0136L19.7626 20.3729L16.1722 15.1626L13.5037 23.9934L11.2793 23.6709ZM22.1107 7.86299L18.9651 10.7862L22.9619 13.1646L22.7712 14.6866L17.2539 11.6764V10.1103L21.3921 6.53906L22.1107 7.86299Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.8678 9.16123H16.3258L18.6018 2.76104L17.2638 1.68305L15.2905 6.67979L11.0757 -0.00683594L9.11118 0.575603L14.8347 9.1119L14.8678 9.16123ZM2.73159 4.26465L13.9894 10.0699V11.9844L3.73889 20.3601L1.61089 18.1695L1.71471 18.0944L11.2274 11.2591L0.912109 6.64963L2.73159 4.26465ZM11.2793 23.6709L15.0545 12.8034L16.6655 12.7725L21.0121 19.0136L19.7626 20.3729L16.1722 15.1626L13.5037 23.9934L11.2793 23.6709ZM22.1107 7.86299L18.9651 10.7862L22.9619 13.1646L22.7712 14.6866L17.2539 11.6764V10.1103L21.3921 6.53906L22.1107 7.86299Z"
              fill="url(#paint0_linear_4618_2358)"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_4618_2358"
            x1="2.51991"
            y1="3.2432"
            x2="21.4095"
            y2="20.141"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ABEA45" />
            <stop offset="1" stopColor="#12D0A2" />
          </linearGradient>
          <clipPath id="clip0_4618_2358">
            <rect width="24" height="24" fill="white" />
          </clipPath>
          <clipPath id="clip1_4618_2358">
            <rect
              width="22.0502"
              height="24"
              fill="white"
              transform="translate(0.912109 -0.00683594)"
            />
          </clipPath>
        </defs>
      </svg>
      <Text
        color="text.t1"
        fontSize={`${fontSize}px`}
        fontWeight="500"
        lineHeight={1.5}
      >
        PumpX
      </Text>
    </HStack>
  );
}
